import { render, staticRenderFns } from "./ProductOne.vue?vue&type=template&id=585b4888&scoped=true"
import script from "./ProductOne.vue?vue&type=script&lang=js"
export * from "./ProductOne.vue?vue&type=script&lang=js"
import style0 from "./ProductOne.vue?vue&type=style&index=0&id=585b4888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b4888",
  null
  
)

export default component.exports